/*
 * Project gallery — chevron arrow navigation.
 *
 * The 50/50 image carousel scrolls natively (overflow-x). The prev/next arrows
 * give it a clear, obvious control (drag + edge-hover alone wasn't intuitive).
 * Each click scrolls by one slide width; arrows disable at the ends. Desktop
 * only — the gallery stacks vertically on mobile, where the arrows are hidden.
 */
(function () {
  function initGallery(wrap) {
    if (wrap.__galleryInit) return;
    wrap.__galleryInit = true;

    var scroller = wrap.querySelector('.project-gallery');
    var prev = wrap.querySelector('[data-gallery-prev]');
    var next = wrap.querySelector('[data-gallery-next]');
    if (!scroller || !prev || !next) return;

    function slideWidth() {
      var slide = scroller.querySelector('.project-gallery__slide');
      return slide ? slide.getBoundingClientRect().width : scroller.clientWidth / 2;
    }

    function step(direction) {
      scroller.scrollBy({ left: direction * slideWidth(), behavior: 'smooth' });
    }

    function updateArrows() {
      var maxScroll = scroller.scrollWidth - scroller.clientWidth - 1;
      prev.disabled = scroller.scrollLeft <= 0;
      next.disabled = scroller.scrollLeft >= maxScroll;
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    scroller.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function initAll() {
    document.querySelectorAll('[data-project-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
